import { useTranslation } from 'react-i18next';
import { useSuperUserDebugSessions } from '@/hooks/useSuperUserDebugSessions.ts';
import SuperUserDebugSessionsFilters from '@/components/superuser/SuperUserDebugSessionsFilters';
import SuperUserDebugSessionsTable from '@/components/superuser/SuperUserDebugSessionsTable';

export default function SuperUserDebugSessionsPage() {
  const { t } = useTranslation();
  const {
    query,
    data,
    isLoading,
    error,
    setFilter,
    setPage,
    setSort,
    reset,
  } = useSuperUserDebugSessions();

  return (
    <div className="space-y-4">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('superuser.debug.sessions.title', 'Histórico de sesiones')}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t(
            'superuser.debug.sessions.subtitle',
            'Vista interna de operaciones · acceso restringido a SuperUser',
          )}
        </p>
      </header>

      <SuperUserDebugSessionsFilters
        query={query}
        onFilterChange={setFilter}
        onSortChange={setSort}
        onReset={reset}
      />

      <SuperUserDebugSessionsTable
        data={data}
        isLoading={isLoading}
        error={error}
        onPageChange={setPage}
      />
    </div>
  );
}
